import React from "react";
import { connect } from "react-redux";
import classnames from "classnames";
import * as actions from "../../actions/actions";
import Loading from "../loading";

import _forEach from "lodash/forEach";
import _values from "lodash/values";
import { KitForm } from "./kit-form";

// wheel event listeners are passive by default in React
// so native event listeners need to be used to be able
// to call evt.preventDefault
export const useWheelEventPreventDefault = () => {
    let ref = React.useRef(null);
    React.useEffect(() => {
        if (ref.current) {
            ref.current.addEventListener("wheel", stopDefaultScroll);
        }

        return () => {
            if (ref.current) {
                ref.current.removeEventListener("wheel", stopDefaultScroll);
            }
        };
    }, [ref]);

    return [ref];
};

const KitsCreate = ({ onChange }) => {
    let handleChange = e => {
        onChange("name", e && e.target ? e.target.value : "");
    };
    let [ref] = useWheelEventPreventDefault();
    return (
        <div className="fat-input" ref={ref}>
            <input
                type="search"
                placeholder="New Kit"
                onChange={handleChange}
                data-test-id="kit-name-input"
            />
            <a
                href="#"
                className="make-a-new-kit ui_plus"
                onClick={e => {
                    e.preventDefault();
                    handleChange();
                }}
            />
        </div>
    );
};

let stopScrollPropagation = e => {
    e.stopPropagation();
};
let stopDefaultScroll = e => {
    e.preventDefault();
};

const KitsDropDown = ({
    iconId,
    loading,
    kits,
    canCreateKit,
    creating,
    kitsFetch,
    kitsAddIcon,
    kitsRemoveIcon,
    kitsInputChange,
    kitsCreateKit
}) => {
    // Fetch kits on mount
    React.useEffect(() => {
        kitsFetch();
    }, []);

    let kitsList = [];
    let kitForm;
    if (!creating) {
        kitsList = kits.map(kit => {
            let iconInKit =
                kit.icon_ids.includes(iconId) ||
                kit.icon_ids.includes(Number(iconId));
            let { name, slug, is_locked, is_public } = kit;
            let classes = classnames("kit-name", {
                "kit-locked": is_locked,
                added: iconInKit
            });
            let linkClasses = classnames({
                ui_kit: iconInKit
            });

            let icons = [];
            if (!is_public) {
                icons.push(
                    <i
                        key="kit-private"
                        className="ui_eye-off"
                        title="Only viewable by you"
                    />
                );
            }

            if (slug != "favorites" && is_locked) {
                // Dont let users add icons to locked kits
                return null;
            }
            let action = iconInKit ? kitsRemoveIcon : kitsAddIcon;
            let onClick = () => {
                action(kit.id, iconId);
            };
            return (
                <li
                    className={classes}
                    key={`kit-${kit.id}`}
                    onClick={onClick}
                    data-test-id="kit-item"
                >
                    <a className={linkClasses}>
                        {name}
                        {icons}
                    </a>
                </li>
            );
        });

        if (canCreateKit) {
            kitForm = (
                <KitsCreate
                    key="kits-create-input"
                    onChange={kitsInputChange}
                />
            );
        } else {
            kitsList.push(
                <li
                    className="get-more-kits"
                    key="kits-get-more"
                    data-test-id="kits-get-more"
                >
                    <a
                        className="ui_plus-circle-filled"
                        href="/accounts/upgrade/"
                    >
                        Get more kits
                    </a>
                </li>
            );
        }
    } else {
        kitForm = <KitForm onSubmit={kitsCreateKit.bind(null, iconId)} />;
    }

    let content;
    if (loading) {
        kitForm = null;
        content = <Loading />;
    } else {
        let listClasses = classnames("popup-kits-list");
        content = (
            <fieldset data-test-id="kits-list" className="kits_list visible">
                <ul className={listClasses} onScroll={stopScrollPropagation}>
                    {kitsList}
                </ul>
            </fieldset>
        );
    }

    return (
        <>
            {content}
            {kitForm}
        </>
    );
};

const mapStateToProps = (state, ownProps) => {
    let { user, kits } = state;
    let { newKit } = kits;
    let canCreateKit =
        user && user.permissions && user.permissions.market == "premium";

    let kitsArr = _values(kits.all);

    let loading = !kitsArr.length;
    let creating = !!Object.keys(newKit || {}).length;
    return {
        loading,
        kits: kitsArr,
        canCreateKit,
        creating
    };
};

export default connect(mapStateToProps, {
    kitsFetch: actions.kitsFetch,
    kitsAddIcon: actions.kitsAddIcon,
    kitsRemoveIcon: actions.kitsRemoveIcon,
    kitsInputChange: actions.kitsInputChange,
    kitsCreateKit: actions.kitsCreateKit
})(KitsDropDown);
